module.exports = __webpack_public_path__ + "static/media/exo-latin-300italic.11cfb668.woff2";